import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _ERROR_MESSAGES;

export var ERROR_CODES;

(function (ERROR_CODES) {
  ERROR_CODES["UNEXPECTED"] = "ERR_0";
  ERROR_CODES["ERR_BAD_OPTION_VALUE"] = "ERR_100";
  ERROR_CODES["ERR_BAD_OPTION"] = "ERR_101";
  ERROR_CODES["ECONNABORTED"] = "ERR_102";
  ERROR_CODES["ETIMEDOUT"] = "ERR_103";
  ERROR_CODES["ERR_NETWORK"] = "ERR_104";
  ERROR_CODES["ERR_FR_TOO_MANY_REDIRECTS"] = "ERR_105";
  ERROR_CODES["ERR_DEPRECATED"] = "ERR_106";
  ERROR_CODES["ERR_BAD_RESPONSE"] = "ERR_107";
  ERROR_CODES["ERR_BAD_REQUEST"] = "ERR_108";
  ERROR_CODES["ERR_NOT_SUPPORT"] = "ERR_109";
  ERROR_CODES["ERR_INVALID_URL"] = "ERR_110";
})(ERROR_CODES || (ERROR_CODES = {}));

export var AXIOS_ERROR_CODES = {
  ERR_BAD_OPTION_VALUE: ERROR_CODES.ERR_BAD_OPTION_VALUE,
  ERR_BAD_OPTION: ERROR_CODES.ERR_BAD_OPTION,
  ECONNABORTED: ERROR_CODES.ECONNABORTED,
  ETIMEDOUT: ERROR_CODES.ETIMEDOUT,
  ERR_NETWORK: ERROR_CODES.ERR_NETWORK,
  ERR_FR_TOO_MANY_REDIRECTS: ERROR_CODES.ERR_FR_TOO_MANY_REDIRECTS,
  ERR_DEPRECATED: ERROR_CODES.ERR_DEPRECATED,
  ERR_BAD_RESPONSE: ERROR_CODES.ERR_BAD_RESPONSE,
  ERR_BAD_REQUEST: ERROR_CODES.ERR_BAD_REQUEST,
  ERR_NOT_SUPPORT: ERROR_CODES.ERR_NOT_SUPPORT,
  ERR_INVALID_URL: ERROR_CODES.ERR_INVALID_URL
};
export var ERROR_MESSAGES = (_ERROR_MESSAGES = {}, _defineProperty(_ERROR_MESSAGES, ERROR_CODES.UNEXPECTED, {
  i18n: 'common:error.unexpectedError',
  description: 'Unexpected error occurred.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_BAD_OPTION_VALUE, {
  i18n: 'common:error.unexpectedError',
  description: 'Invalid or unsupported value provided in axios configuration.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_BAD_OPTION, {
  i18n: 'common:error.unexpectedError',
  description: 'Invalid option provided in axios configuration.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ECONNABORTED, {
  i18n: 'common:error.network',
  description: 'Request timed out due to exceeding timeout specified in axios configuration.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ETIMEDOUT, {
  i18n: 'common:error.network',
  description: 'Request timed out due to exceeding default axios timelimit.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_NETWORK, {
  i18n: 'common:error.network',
  description: 'Network-related issue.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_FR_TOO_MANY_REDIRECTS, {
  i18n: 'common:error.unexpectedError',
  description: 'Request is redirected too many times; exceeds max redirects specified in axios configuration.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_DEPRECATED, {
  i18n: 'common:error.unexpectedError',
  description: 'The value of the option is invalid'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_BAD_RESPONSE, {
  i18n: 'common:error.unexpectedError',
  description: 'Response cannot be parsed properly or is in an unexpected format.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_BAD_REQUEST, {
  i18n: 'common:error.unexpectedError',
  description: 'Requested has unexpected format or missing required parameters.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_NOT_SUPPORT, {
  i18n: 'common:error.unexpectedError',
  description: 'Feature or method not supported in the current axios environment.'
}), _defineProperty(_ERROR_MESSAGES, ERROR_CODES.ERR_INVALID_URL, {
  i18n: 'common:error.unexpectedError',
  description: 'Invalid URL provided for axios request.'
}), _ERROR_MESSAGES);